import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Typography, Button } from '@material-ui/core';
import LazyLoad from 'react-lazyload';

// CONSTANTS
import { ROUTE_ABOUT } from '@/constants/routes';
import { LOCATIONS_HOME_PAGE } from '@/constants/locations';

// UTILITY
import { getS3ImageUrl } from '@/utility/content';

// COMPONENTS
import Link from '@/components/Link';
import Image from '@/components/Image';

// HELP
import { WhoWeAreContainer } from './styles';

const imageSrc = getS3ImageUrl('/about-home-page-3.png');
const imageSrcSet = getS3ImageUrl('/about-home-page-3.webp');

const WhoWeAre = ({ t, bg }) => {
  return (
    <WhoWeAreContainer className={`section section--${bg} who-we-are content-visibility--auto`}>
      <div className="section page-content">
        <Grid container spacing={4} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} sm={6} md={5}>
            <p className="subtitle-secondary text-color text-color--purple">
              {t('home.whoWeAre.subtitle')}
            </p>
            <Typography className="m-b-30" variant="h3">
              {t('home.whoWeAre.title')}
            </Typography>
            <p className="p3 m-b-30">
              {t('home.whoWeAre.text1')}
              <br />
              <br />
              {t('home.whoWeAre.text2')}
            </p>
            <Button
              color="secondary"
              component={Link}
              to={ROUTE_ABOUT}
              location={LOCATIONS_HOME_PAGE}
            >
              {t('buttons.learnMore')}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className="who-we-are__image-wrap">
              <LazyLoad once>
                <Image
                  src={imageSrc}
                  srcSet={imageSrcSet}
                  className="who-we-are__image"
                  alt="Who we are?"
                />
              </LazyLoad>
            </div>
          </Grid>
        </Grid>
      </div>
    </WhoWeAreContainer>
  );
};

WhoWeAre.defaultProps = {
  bg: 'white',
};

WhoWeAre.propTypes = {
  t: PropTypes.func.isRequired,
  bg: PropTypes.string,
};

export default withTranslation()(React.memo(WhoWeAre));
